module.exports = __webpack_public_path__ + "static/media/document-icon.e2360cb6.png";